import prettysize from '../../../utils'
import React from 'react'
import './styles.scss'

export default ({ total_files_size }) => (
  <div className='total-files-size center-child indicator shadow'>
    <div className='content small-size'>
      <span>Size:</span>
      <span>{prettysize(total_files_size ? total_files_size : 0)}</span>
    </div>
  </div>
)
